import { catchError, Observable, of, OperatorFunction } from 'rxjs';
import { NotFound } from 'http-errors';

export function errorPipe(error: Observable<unknown>): Observable<undefined> {
  return error.pipe(
    catchError((err) => {
      if (err instanceof NotFound) {
        return of(undefined);
      }
      throw err;
    }) as OperatorFunction<unknown, undefined>
  );
}
